import React, { useState,useEffect } from "react";
import { Button, Row, Col, Typography, Card, Form, Input, Tabs, message, Spin, Divider } from "antd";
import { jwtDecode } from 'jwt-decode';
import jwtEncode from 'jwt-encode';
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../Components/Constant";
import ApiService from "../Components/apiService";
import { LockOutlined, UserOutlined, MailOutlined } from "@ant-design/icons";
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;


const DiffInsightLandingPage = () => {
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  // Add CSS animations
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-20px); }
      }
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .animate-fadeInUp {
        animation: fadeInUp 0.6s ease forwards;
      }
    `;
    document.head.appendChild(style);
    
    // Trigger animations
    setTimeout(() => setIsVisible(true), 100);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Handle OAuth callback - updated for PKCE flow
  useEffect(() => {
    const handleOAuthCallback = () => {
      console.log('here i am');
      // Only handle OAuth callback if we're on the callback URL or have OAuth parameters
      const urlParams = new URLSearchParams(window.location.search);
      const success = urlParams.get('success');
      const error = urlParams.get('error');
      const token = urlParams.get('token');
      const action = urlParams.get('action');
      const user_id = urlParams.get('user_id');
      const username = urlParams.get('username');
      const email = urlParams.get('email');
      const name = urlParams.get('name');
      const org_id = urlParams.get('org_id');
      const currency = urlParams.get('currency');
      console.log('success:', success, 'error:', error, 'token:', token);
      if (error) {
        setGoogleLoading(false);
        // Handle different error types
        let errorMessage = 'Authentication failed';
        switch (error) {
          case 'token_exchange_failed':
            errorMessage = 'Failed to exchange authorization code with Google';
            break;
          case 'account_inactive':
            errorMessage = 'Your account is inactive. Please contact administrator.';
            break;
          case 'no_authorization_code':
            errorMessage = 'Authorization code not received from Google';
            break;
          case 'processing_failed':
            errorMessage = 'Failed to process authentication';
            break;
          case 'callback_failed':
            errorMessage = 'OAuth callback failed';
            break;
          default:
            errorMessage = decodeURIComponent(error);
        }
        message.error(`OAuth Error: ${errorMessage}`);
        
        // Clean up URL parameters
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
      }

      if (success === 'true' && token) {
        setGoogleLoading(false);
        const cookieOptions = {
          expires: 7,
          secure: true,
          sameSite: "None"
        };
      
        const currentTime = Date.now().toString();
        Cookies.set("tokenRes", token, cookieOptions);
        Cookies.set("loginTime", currentTime, cookieOptions);
        Cookies.set("username", username, cookieOptions);
        Cookies.set("email", email, cookieOptions);
        Cookies.set("userId", user_id, cookieOptions);
        Cookies.set("orgId", org_id, cookieOptions);
        Cookies.set("userCurrency", currency, cookieOptions);
        

        // Show success message based on action
        let successMessage = 'Google authentication successful!';
        switch (action) {
          case 'login':
            successMessage = 'Google sign in successful!';
            break;
          case 'linked':
            successMessage = 'Google account linked and signed in successfully!';
            break;
          case 'created':
            successMessage = 'Account created successfully with Google!';
            break;
          case 'existing_login':
            successMessage = 'Account already exists. Signed in successfully.';
            break;
          case 'linked_login':
            successMessage = 'Google account linked to existing email and signed in successfully!';
            break;
          default:
            successMessage = 'Google authentication successful!';
            break;
        }
        
        message.success(successMessage);
        
        // Clean up URL parameters
        window.history.replaceState({}, document.title, window.location.pathname);
        
        // Navigate to dashboard
        navigate("/diffinsight/home");
      }
    };

    handleOAuthCallback();
  }, [navigate]);

  const onFinish = async (values, type) => {
    setLoading(true);
    try {
      if (type === "login") {
        // For login send encoded token payload under { tokens: token }
        const token = jwtEncode(
          { username: values.username, password: values.password },
          "OUR_SECRET",
          { algorithm: "HS256" }
        );

        // Optional: verify payload (keeps previous behavior)
        try { jwtDecode(token); } catch (e) { /* ignore decode errors for now */ }

        const apiService = new ApiService(
          `${BASE_URL}/login`,
          { "Content-Type": "application/json" },
          "POST",
          { tokens: token }
        );

        const response = await apiService.makeCall();

        // handle response (login expected to return token and user)
        const tokenRes = response.token || response.tokenRes || null;
        const user = response.user || response.data || {};
        const username = user.username || values.username;
        const email = response.user.email;
        const name = response.user.Name;
        const userId = response.user._id;
        const orgId = response.user.org_id;
        const loginUserCurrency = response.user.currency;
        const currentTime = Date.now().toString();

        if (token && username && email) {
          Cookies.set("tokenRes", tokenRes, { expires: 7 });
          Cookies.set("username", username, { expires: 7 });
          Cookies.set("email", email, { expires: 7 });
          Cookies.set("name", name, { expires: 7 });
          Cookies.set("userId", userId, { expires: 7 });
          Cookies.set("orgId", orgId, { expires: 7 });
          Cookies.set("userCurrency", loginUserCurrency, { expires: 7 });
          Cookies.set("loginTime", currentTime, { expires: 7 });
        }

      } else if (type === "signup") {
        // For signup call register endpoint with user object
        const body = {
          username: values.username,
          password: values.password,
          Name: values.name,
          email: values.email,
          loggedIn: true,
        };

         const apiService = new ApiService(
          `${BASE_URL}/register_for_diffinsights`,
          { "Content-Type": "application/json" },
          "POST",
          { user: body }
        );

        const response = await apiService.makeCall();

        // If register returns token + user, persist cookies similar to login
        const tokenRes = response.token || response.tokenRes || null;
        const user = response.user || response.data || {};
        const username = user.username || values.username;
        const email = response.user.email;
        const name = response.user.Name;
        const userId = response.user._id;
        const orgId = response.user.org_id;
        const loginUserCurrency = response.user.currency;
        const currentTime = Date.now().toString();

        if (tokenRes && username && email) {
          Cookies.set("tokenRes", tokenRes, { expires: 7 });
          Cookies.set("username", username, { expires: 7 });
          Cookies.set("email", email, { expires: 7 });
          Cookies.set("name", name, { expires: 7 });
          Cookies.set("userId", userId, { expires: 7 });
          Cookies.set("orgId", orgId, { expires: 7 });
          Cookies.set("userCurrency", loginUserCurrency, { expires: 7 });
          Cookies.set("loginTime", currentTime, { expires: 7 });
        }
      }

      setLoading(false);
      navigate("/diffinsight/home");
    } catch (err) {
      setLoading(false);
      const errorMessage =
        err && typeof err === "object"
          ? Object.entries(err)
              .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`)
              .join(" | ")
          : "Login failed! Enter Correct Credentials.";
      message.error(errorMessage);
    }
  };

  const handleLoginWithGoogle = (flow = 'login') => {
    setGoogleLoading(true);
    // const token = Cookies.get("tokenRes");
    // const userId = Cookies.get("userId");
    // const email = Cookies.get("email");
    // const loginTime = Cookies.get("loginTime"); 
    // let isTokenValid = false;

    // if (token && userId && email && loginTime) {
    //   console.log("User already logged in");
      
    //   const decodedToken = jwtDecode(token);
    //   const loginTimestamp = parseInt(loginTime);
    //   const expirationTime = loginTimestamp + (7 * 24 * 60 * 60 * 1000); // 7 days in milliseconds
    //   const currentTime = Date.now();
    //   isTokenValid = currentTime < expirationTime;
      
    //   // Check if token is not expired
    //   if (isTokenValid) {
    //     message.success("Welcome back! You're already logged in.");
    //     navigate("/Home");
    //     return;
    //   }
    // }
    // Add state parameter to differentiate between login and signup
    const state = flow === 'signup' ? 'signup' : 'login';
    
    // Add prompt parameter to control re-authentication behavior
    const promptParam = flow === 'login' ? 'select_account' : 'consent';
    
    const apiService = new ApiService(
      `${BASE_URL}/auth/google/url?state=${state}&prompt=${promptParam}`,
      { "Content-Type": "application/json" },
      "GET"
    );

    apiService.makeCall().then(response => {
      if (response && response.auth_url) {
        // Add a small delay to show the loading state
        setTimeout(() => {
          window.location.href = response.auth_url;
        }, 500);
      } else {
        setGoogleLoading(false);
        message.error("Unable to get Google authentication URL");
      }
    }).catch(err => {
      setGoogleLoading(false);
      const errorMessage = err && typeof err === "object"
        ? Object.entries(err)
            .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`)
            .join(" | ")
        : "Google authentication failed!";
      message.error(errorMessage);
    });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1D3557 0%, #457B9D 50%, #FCD6C7 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background decorative elements */}
      <div
        style={{
          position: "absolute",
          top: "-50px",
          right: "-50px",
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          background: "rgba(254, 114, 0, 0.1)",
          animation: "float 6s ease-in-out infinite",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-100px",
          left: "-100px",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.05)",
          animation: "float 8s ease-in-out infinite reverse",
        }}
      />

      {/* Header */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          padding: "20px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#FFFFFF",
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(-20px)",
            transition: "all 0.8s ease",
          }}
        >
          Aptify
        </div>
        {/* <Button
          type="text"
          onClick={() => navigate("/")}
          style={{
            color: "#FFFFFF",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            borderRadius: "6px",
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(-20px)",
            transition: "all 0.8s ease 0.2s",
          }}
        >
          Back to Home
        </Button> */}
      </div>

      <Row style={{ minHeight: "100vh", paddingTop: "80px" }}>
        {/* Left: Authentication Form */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px",
          }}
        >
          <Card
            style={{
              width: "100%",
              maxWidth: "450px",
              borderRadius: "20px",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              background: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(20px)",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.9)",
              transition: "all 1s ease 0.3s",
            }}
            bodyStyle={{ padding: "40px" }}
          >
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <Title level={2} style={{ color: "#1D3557", marginBottom: "8px", fontSize: "28px" }}>
                Welcome to Diff Insight
              </Title>
              <Paragraph style={{ color: "#457B9D", fontSize: "16px" }}>
                Sign in to your account or create a new one
              </Paragraph>
            </div>

            <Tabs 
              defaultActiveKey="login" 
              centered
              style={{
                marginBottom: "20px",
              }}
              tabBarStyle={{
                borderBottom: "2px solid #f0f0f0",
                marginBottom: "30px",
              }}
            >
              <TabPane 
                tab={
                  <span style={{ fontSize: "16px", fontWeight: "500", padding: "8px 16px" }}>
                    Sign In
                  </span>
                } 
                key="login"
              >
                <Form 
                  layout="vertical" 
                  onFinish={(values) => onFinish(values, "login")}
                  style={{ marginTop: "20px" }}
                >
                  <Form.Item
                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Username</span>}
                    name="username"
                    rules={[{ required: true, message: "Please enter your username" }]}
                  >
                    <Input 
                      prefix={<UserOutlined style={{ color: "#457B9D" }} />}
                      placeholder="Enter your username" 
                      size="large"
                      style={{
                        borderRadius: "8px",
                        border: "2px solid #f0f0f0",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#FE7200";
                        e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#f0f0f0";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Password</span>}
                    name="password"
                    rules={[{ required: true, message: "Please enter your password" }]}
                  >
                    <Input.Password 
                      prefix={<LockOutlined style={{ color: "#457B9D" }} />}
                      placeholder="Enter your password" 
                      size="large"
                      style={{
                        borderRadius: "8px",
                        border: "2px solid #f0f0f0",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#FE7200";
                        e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#f0f0f0";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </Form.Item>
                  <Form.Item style={{ marginBottom: "20px" }}>
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      block 
                      size="large"
                      loading={loading}
                      style={{
                        backgroundColor: "#FE7200",
                        borderColor: "#FE7200",
                        borderRadius: "8px",
                        height: "50px",
                        fontSize: "16px",
                        fontWeight: "600",
                        boxShadow: "0 4px 12px rgba(254, 114, 0, 0.3)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 8px 20px rgba(254, 114, 0, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 12px rgba(254, 114, 0, 0.3)";
                      }}
                    >
                      {loading ? <Spin /> : "Sign In"}
                    </Button>
                  </Form.Item>
                </Form>

                <Divider 
                  plain 
                  style={{ 
                    color: "#8898aa", 
                    fontSize: "14px",
                    margin: "20px 0"
                  }}
                >
                  or continue with
                </Divider>

                <div style={{ position: 'relative' }}>
                  <Button
                    block
                    size="large"
                    disabled={googleLoading || loading}
                    style={{
                      backgroundColor: '#ffffff',
                      color: '#3c4043',
                      border: '1px solid #dadce0',
                      height: '50px',
                      fontWeight: '500',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '12px',
                      fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
                      boxShadow: '0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15)',
                    }}
                    onMouseEnter={(e) => {
                      if (!googleLoading && !loading) {
                        e.target.style.backgroundColor = '#f8f9fa';
                        e.target.style.borderColor = '#dadce0';
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 2px 4px 0 rgba(60,64,67,.30), 0 2px 6px 2px rgba(60,64,67,.15)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!googleLoading && !loading) {
                        e.target.style.backgroundColor = '#ffffff';
                        e.target.style.borderColor = '#dadce0';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15)';
                      }
                    }}
                    onClick={() => handleLoginWithGoogle('login')}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      style={{ marginRight: '8px' }}
                    >
                      <path
                        fill="#4285F4"
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                      />
                      <path
                        fill="#34A853"
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                      />
                      <path
                        fill="#FBBC05"
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                      />
                      <path
                        fill="#EA4335"
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                      />
                    </svg>
                    Continue with Google
                  </Button>
                  {googleLoading && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                      }}
                    >
                      <Spin size="default" />
                    </div>
                  )}
                </div>
              </TabPane>

              <TabPane 
                tab={
                  <span style={{ fontSize: "16px", fontWeight: "500", padding: "8px 16px" }}>
                    Sign Up
                  </span>
                } 
                key="signup"
              >
                <Form 
                  layout="vertical" 
                  onFinish={(values) => onFinish(values, "signup")}
                  style={{ marginTop: "20px" }}
                >
                  <Form.Item
                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Full Name</span>}
                    name="name"
                    rules={[{ required: true, message: "Please enter your full name" }]}
                  >
                    <Input 
                      prefix={<UserOutlined style={{ color: "#457B9D" }} />}
                      placeholder="Enter your full name" 
                      size="large"
                      style={{
                        borderRadius: "8px",
                        border: "2px solid #f0f0f0",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#FE7200";
                        e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#f0f0f0";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Username</span>}
                    name="username"
                    rules={[{ required: true, message: "Please enter a username" }]}
                  >
                    <Input 
                      prefix={<UserOutlined style={{ color: "#457B9D" }} />}
                      placeholder="Choose a username" 
                      size="large"
                      style={{
                        borderRadius: "8px",
                        border: "2px solid #f0f0f0",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#FE7200";
                        e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#f0f0f0";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Email Address</span>}
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                  >
                    <Input 
                      prefix={<MailOutlined style={{ color: "#457B9D" }} />}
                      placeholder="you@company.com" 
                      size="large"
                      style={{
                        borderRadius: "8px",
                        border: "2px solid #f0f0f0",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#FE7200";
                        e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#f0f0f0";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Password</span>}
                    name="password"
                    rules={[
                      { required: true, message: "Please enter a password" },
                      { min: 6, message: "Password must be at least 6 characters" }
                    ]}
                  >
                    <Input.Password 
                      prefix={<LockOutlined style={{ color: "#457B9D" }} />}
                      placeholder="Create a strong password" 
                      size="large"
                      style={{
                        borderRadius: "8px",
                        border: "2px solid #f0f0f0",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#FE7200";
                        e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#f0f0f0";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </Form.Item>
                  <Form.Item style={{ marginBottom: "20px" }}>
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      block 
                      size="large"
                      loading={loading}
                      style={{
                        backgroundColor: "#FE7200",
                        borderColor: "#FE7200",
                        borderRadius: "8px",
                        height: "50px",
                        fontSize: "16px",
                        fontWeight: "600",
                        boxShadow: "0 4px 12px rgba(254, 114, 0, 0.3)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 8px 20px rgba(254, 114, 0, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 12px rgba(254, 114, 0, 0.3)";
                      }}
                    >
                      Create Account
                    </Button>
                  </Form.Item>
                </Form>

                <Divider 
                  plain 
                  style={{ 
                    color: "#8898aa", 
                    fontSize: "14px",
                    margin: "20px 0"
                  }}
                >
                  or continue with
                </Divider>

                <div style={{ position: 'relative' }}>
                  <Button
                    block
                    size="large"
                    disabled={googleLoading || loading}
                    style={{
                      backgroundColor: '#ffffff',
                      color: '#3c4043',
                      border: '1px solid #dadce0',
                      height: '50px',
                      fontWeight: '500',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '12px',
                      fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
                      boxShadow: '0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15)',
                    }}
                    onMouseEnter={(e) => {
                      if (!googleLoading && !loading) {
                        e.target.style.backgroundColor = '#f8f9fa';
                        e.target.style.borderColor = '#dadce0';
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 2px 4px 0 rgba(60,64,67,.30), 0 2px 6px 2px rgba(60,64,67,.15)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!googleLoading && !loading) {
                        e.target.style.backgroundColor = '#ffffff';
                        e.target.style.borderColor = '#dadce0';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15)';
                      }
                    }}
                    onClick={() => handleLoginWithGoogle('signup')}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      style={{ marginRight: '8px' }}
                    >
                      <path
                        fill="#4285F4"
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                      />
                      <path
                        fill="#34A853"
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                      />
                      <path
                        fill="#FBBC05"
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                      />
                      <path
                        fill="#EA4335"
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                      />
                    </svg>
                    Sign up with Google
                  </Button>
                  {googleLoading && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                      }}
                    >
                      <Spin size="default" />
                    </div>
                  )}
                </div>
              </TabPane>

              
            </Tabs>
          </Card>
        </Col>

        {/* Right: Features */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: "60px 40px",
            background: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(10px)",
            borderRadius: "10px",
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.9)",
            transition: "all 1s ease 0.5s",
          }}
        >
          <Title style={{ fontSize: "40px" ,color: '#1D3557'}}>Compare your Salesforce data instantly</Title>
          <Paragraph style={{ fontSize: "18px", marginBottom: "40px" }}>
            Make your Salesforce migration easy and secure. We never store your data.
          </Paragraph>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={12}>
              <Card hoverable style={{ borderRadius: "8px", textAlign: "center",height:'150px' }}>
                <Title level={4} style={{color: '#FE7200'}}>No Data Stored</Title>
                <Paragraph>
                  Your Salesforce data remains completely secure. We don’t store any data.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card hoverable style={{ borderRadius: "8px", textAlign: "center",height:'150px' }}>
                <Title level={4} style={{color: '#FE7200'}}>Compare Data in Seconds</Title>
                <Paragraph>
                  Quickly identify differences between Salesforce instances and speed up your audits.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card hoverable style={{ borderRadius: "8px", textAlign: "center",height:'150px' }}>
                <Title level={4} style={{color: '#FE7200'}}>Easy Migration</Title>
                <Paragraph>
                  Simplify your Salesforce migrations with automated insights and comparisons.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card hoverable style={{ borderRadius: "8px", textAlign: "center",height:'150px' }}>
                <Title level={4} style={{color: '#FE7200'}}>Detailed Reports</Title>
                <Paragraph>
                  Generate comprehensive reports with actionable insights for your migration team.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

    </div>
  );
};

export default DiffInsightLandingPage;
